// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"053abe45","217":"d229b3e8","307":"7d1a2ff9","341":"d9cb7081","739":"053abe45"}[chunkId] + ".chunk.css";
};